import { Injectable } from '@angular/core';
import { KioskSettings, ShoppingCart } from '../models/models';
import * as tools from '../tools';
import { Waiver } from '../models/waiver';
import { WaiverSteps } from '../alv-enums';

@Injectable({
  providedIn: 'root',
})
export class StoreService {

  public userName: string;
  public userEmail: string;
  public shoppingCart: ShoppingCart;
  public waiver : Waiver;
  public loading: boolean;
  public gatewaySubscriptionName: string;
  public kioskSettings: KioskSettings;
  public currentWaiverStep : WaiverSteps;
  public requestToken: string;
	antiForgeryToken: string;
  constructor() {
		
    // hard-coded for now
    this.userName = 'John Smith';
    this.userEmail = 'john_smith@aluvii.com';
		this.gatewaySubscriptionName = 'kiosk_' + tools.guidGenerator();

    this.kioskSettings = new KioskSettings();
  }

}
